<template>
  <div>
    <dl
      class="row"
      v-if="
        billingInformations.billing_entity_type ===
        BILLING_ENTITY_TYPE_INDIVIDUAL
      "
    >
      <dt class="col-sm-4">{{ $t("COMMON.LASTNAME") }}</dt>
      <dd class="col-sm-8">
        {{ billingInformations.billing_lastname }}
      </dd>
    </dl>

    <dl
      class="row"
      v-if="
        billingInformations.billing_entity_type ===
        BILLING_ENTITY_TYPE_INDIVIDUAL
      "
    >
      <dt class="col-sm-4">{{ $t("COMMON.FIRSTNAME") }}</dt>
      <dd class="col-sm-8">
        {{ billingInformations.billing_firstname }}
      </dd>
    </dl>

    <dl
      class="row"
      v-if="
        billingInformations.billing_entity_type === BILLING_ENTITY_TYPE_COMPANY
      "
    >
      <dt class="col-sm-4">{{ $t("COMMON.COMPANY_NAME") }}</dt>
      <dd class="col-sm-8">
        {{ billingInformations.billing_company_name }}
      </dd>
    </dl>

    <dl class="row">
      <dt class="col-sm-4">{{ $t("COMMON.COUNTRY") }}</dt>
      <dd class="col-sm-8">
        {{ billingInformations.billing_country }}
      </dd>
    </dl>

    <dl class="row">
      <dt class="col-sm-4">{{ $t("COMMON.STATE") }}</dt>
      <dd class="col-sm-8">
        {{ billingInformations.billing_state }}
      </dd>
    </dl>

    <dl class="row">
      <dt class="col-sm-4">{{ $t("COMMON.CITY") }}</dt>
      <dd class="col-sm-8">
        {{ billingInformations.billing_city }}
      </dd>
    </dl>

    <dl class="row">
      <dt class="col-sm-4">{{ $t("COMMON.ZIPCODE") }}</dt>
      <dd class="col-sm-8">
        {{ billingInformations.billing_zipcode }}
      </dd>
    </dl>

    <dl class="row">
      <dt class="col-sm-4">{{ $t("COMMON.ADDRESS") }}</dt>
      <dd class="col-sm-8">
        {{ billingInformations.billing_address }}
      </dd>
    </dl>

    <dl class="row">
      <dt class="col-sm-4">{{ $t("COMMON.EMAIL") }}</dt>
      <dd class="col-sm-8">
        {{ billingInformations.billing_email }}
      </dd>
    </dl>
  </div>
</template>

<script>
import {
  BILLING_ENTITY_TYPE_INDIVIDUAL,
  BILLING_ENTITY_TYPE_COMPANY,
} from "@/constants/billingInformations";

export default {
  name: "billing-informations-view",

  components: {},

  props: ["billingInformations"],

  data() {
    return {
      BILLING_ENTITY_TYPE_INDIVIDUAL: BILLING_ENTITY_TYPE_INDIVIDUAL,
      BILLING_ENTITY_TYPE_COMPANY: BILLING_ENTITY_TYPE_COMPANY,
    };
  },

  computed: {},

  created() {},

  methods: {},

  mounted() {},

  watch: {
    billingInformations(billingInformations) {},
  },
};
</script>
